import {
  REQUEST_CASETIMELOG_ADD,
  RECEIVE_CASETIMELOG_ADD,
  ERROR_CASETIMELOG_ADD,
  REQUEST_CASETIMELOG_PAIDLIST,
  RECEIVE_CASETIMELOG_PAIDLIST,
  ERROR_CASETIMELOG_PAIDLIST,
  REQUEST_PAYPERIOD_USERS,
  RECEIVE_PAYPERIOD_USERS,
  ERROR_PAYPERIOD_USERS,
  REQUEST_CASETIMELOG_BYCASE,
  RECEIVE_CASETIMELOG_BYCASE,
  ERROR_CASETIMELOG_BYCASE,
  RECEIVE_PAYPERIOD_APPROVED_GETLIST,
  REQUEST_CASETIMELOG_PAYPERIOD,
  RECEIVE_CASETIMELOG_PAYPERIOD,
  ERROR_CASETIMELOG_PAYPERIOD,
  REQUEST_PAYPERIOD_GETLIST,
  RECEIVE_PAYPERIOD_GETLIST,
  ERROR_PAYPERIOD_GETLIST,
  REQUEST_CASETIMELOG_UPDATE,
  RECEIVE_CASETIMELOG_UPDATE,
  ERROR_CASETIMELOG_UPDATE,
  REQUEST_CASETIMELOG_DELETE,
  RECEIVE_CASETIMELOG_DELETE,
  ERROR_CASETIMELOG_DELETE,
} from "typeConstants";
import { caseTimeLog as initialState } from "../initialState.tsx";

const caseTimeLog = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CASETIMELOG_ADD:
      return {
        ...state,
        fetching: true
      };
    case RECEIVE_CASETIMELOG_ADD:
      return {
        ...state,
        timeLog: action.payload,
        fetching: false
      };
    case ERROR_CASETIMELOG_ADD:
      return {
        ...state,
        fetching: false
      };

    case REQUEST_CASETIMELOG_BYCASE:
    case REQUEST_CASETIMELOG_PAIDLIST:
    case REQUEST_CASETIMELOG_PAYPERIOD:
      return {
        ...state,
        isFetchingTimeLogs: true
      };

    case RECEIVE_CASETIMELOG_BYCASE:
    case RECEIVE_CASETIMELOG_PAIDLIST:
    case RECEIVE_CASETIMELOG_PAYPERIOD:
      return {
        ...state,
        timeLogs: action.payload,
        isFetchingTimeLogs: false
      };

    case ERROR_CASETIMELOG_BYCASE:
    case ERROR_CASETIMELOG_PAIDLIST:
    case ERROR_CASETIMELOG_PAYPERIOD:
      return {
        ...state,
        isFetchingTimeLogs: false
      };

    case REQUEST_PAYPERIOD_GETLIST:
      return {
        ...state,
        isFetchingPayPeriods: true
      };

    case RECEIVE_PAYPERIOD_GETLIST:
      return {
        ...state,
        payPeriods: action.payload,
        isFetchingPayPeriods: false
      };
    case ERROR_PAYPERIOD_GETLIST:
      return {
        ...state,
        isFetchingPayPeriods: false
      };
    case REQUEST_PAYPERIOD_USERS:
      return {
        ...state,
        isFetchingPayPeriodUsers: true
      };

    case RECEIVE_PAYPERIOD_USERS:
      return {
        ...state,
        payPeriodUsers: action.payload,
        isFetchingPayPeriodUsers: false
      };
    case ERROR_PAYPERIOD_USERS:
      return {
        ...state,
        isFetchingPayPeriodUsers: false
      };
    case RECEIVE_PAYPERIOD_APPROVED_GETLIST:
      return {
        ...state,
        approvedPayPeriod: action.payload
      };
    case REQUEST_CASETIMELOG_UPDATE:
      return {
        ...state,
        isUpdatingTimeLogs: true
      };
    case RECEIVE_CASETIMELOG_UPDATE:
      return {
        ...state,
        isUpdatingTimeLogs: false
      };
    case ERROR_CASETIMELOG_UPDATE:
      return {
        ...state,
        isUpdatingTimeLogs: false
      };
    case REQUEST_CASETIMELOG_DELETE:
      return {
        ...state,
        isDeletingTimeLogs: true
      };
    case RECEIVE_CASETIMELOG_DELETE:
      return {
        ...state,
        isDeletingTimeLogs: false
      };
    case ERROR_CASETIMELOG_DELETE:
      return {
        ...state,
        isDeletingTimeLogs: false
      };  
    default:
      return state;
  }
};

export default caseTimeLog;
